import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { localizationResources } from '@/localization/translations/localizationResources';
import {
  Locale,
  LocalizationNameSpace
} from '@/localization/types/localizationTypes';

// oxlint-disable-next-line import/no-named-as-default-member
i18next.use(initReactI18next).init({
  resources: localizationResources,
  lng: Locale.DE,
  fallbackLng: Locale.DE,
  supportedLngs: [Locale.EN, Locale.DE],
  ns: [LocalizationNameSpace.AUTHORIZATION, LocalizationNameSpace.NAVIGATION],
  interpolation: {
    escapeValue: false // react already safes from xss
  },
  react: {
    transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'ul', 'li'] // do not transform <br/> to <br></br>
  }
});
